import React from "react";
import logo from '../asset/images/logos/white-logo.png'
import leftArrow from '../asset/images/new/left-arrow.png'
import { Link, useNavigate } from 'react-router-dom';


const HeaderComponent = ({ showBack }) => {

    const navigate = useNavigate()

    return (
        <div className="container d-flex align-items-center justify-content-between">
            <div>
                <img
                    src={logo}
                    alt="SNB Logo"
                    className='login-logo'
                />
                <p className="text-white mt-2">2025 | SNB Nexus</p>
            </div>
            {
                showBack &&
            <button className="back-btn" onClick={() => navigate('/home')}>
                <img src={leftArrow} alt="" />
                Back
            </button>
            }
        </div>
    )
}

export default HeaderComponent;